import { bindActionCreators } from '@reduxjs/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { showMessageModal } from '../../actions/event';
import { trackConversionEvent } from '../../actions/tracking';
import { getItem, getItemAuctionUrl, getItemContact } from '../../selectors/item';

import { conversionEvents } from '../../shared/tracking';

import { getRetailerId } from '../../selectors/retailer';
import ContactChat from './contact-chat';
import EmailButton from './email-button';
import MessageButton from './message-button';
import PhonenumberButton from './phonenumber-button';

const Contact = () => {
  const { t } = useTranslation('item');
  const dispatch = useDispatch();
  const data = useSelector(getItemContact);
  const item = useSelector(getItem);
  const auctionUrl = useSelector(getItemAuctionUrl);
  const retailerId = useSelector(getRetailerId);

  const actions = bindActionCreators(
    {
      trackConversionEvent,
      showMessageModal,
    },
    dispatch,
  );
  if (!data) return null;

  const onAuctionClick = () =>
    actions.trackConversionEvent(item, conversionEvents.CONVERSION_ACTION_AUCTION_CLICK);

  return (
    <>
      {auctionUrl ? (
        <a
          href={auctionUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-wx-button="action full-width"
          title={t('To auction', { ns: 'item' })}
          onClick={onAuctionClick}
        >
          <div className="button-icon">
            <i className="icon-auction no-margin" />
          </div>
          <div className="button-text">{t('To auction', { ns: 'item' })}</div>
        </a>
      ) : (
        <>
          {!!retailerId && (
            <MessageButton
              isLight={false}
              onClick={actions.showMessageModal}
              label={t('Send message', { ns: 'item' })}
            />
          )}
          <PhonenumberButton
            label={t('Show phone number', { ns: 'item' })}
            isLight
            trackingContext="card"
          />
          <EmailButton label={t('Send e-mail', { ns: 'item' })} isLight />
          <ContactChat isLight />
        </>
      )}
    </>
  );
};

export default Contact;
